
import { Component, Vue } from 'vue-property-decorator';

@Component({
	name: 'ContentNavigation'
})
export default class ContentNavigation extends Vue {
	categories = [
		{ name: 'Recruiting', value: 'recruiting', _id: 1 },
		{ name: 'Downloads', value: 'downloads', _id: 2 },
		{ name: 'Partner', value: 'partners', _id: 3 },
		{ name: 'Events', value: 'events', _id: 4 },
		{ name: 'Webinare', value: 'webinars', _id: 5 },
		{ name: 'Podcasts', value: 'podcasts', _id: 6 }
	];

	showDropdown = false;
}
